import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DrawerModule } from 'primeng/drawer';

@Component({
  selector: 'app-comp-review-view-details',
  standalone: true,
  imports: [DrawerModule, FormsModule, CommonModule, NgClass, ToastModule],
  templateUrl: './comp-review-view-details.component.html',
  styleUrl: './comp-review-view-details.component.scss'
})
export class CompReviewViewDetailsComponent {
  @Input() rowData: any;
  @Input() value!: string;
  @Input() screenType!: string;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() correctCodeLength!: number;
  @Input() index: number | any;
  isLoadingResults: boolean = false;
  isSelectedeDetails: boolean = false;
  isSampleRecord: boolean = false;
  catHeader:any='CAT Event';
  clientHeader:any='Source Transaction';
  fieldsName:any="";
  catLegDetails: any[] = [];
  clientLegDetails: any[] = [];



  View: boolean = true;
  SelectedRowData: any;
  SelectedRowDataLegDetails : any;
  
  constructor(
    private UrlsService: UrlsService,
    private messageService: MessageService,
    public UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    public constantService: ConstantService) { }


  ngOnInit(): void {
    this.isSampleRecord = this.rowData['recordType'] == "SAMPLE";
    this.getCompareViewDetails();
  }

  getCompareViewDetails() {
    if (this.rowData && this.rowData != undefined) {
      let data = {
        'firmROEID': this.rowData['firmROEID'],
        "groupName": this.rowData['groupName'],
        "mpid": this.UserService.getActiveMPID(),
        'reportDate': this.rowData['reportDate'],
        'type': this.rowData['type'],
        "orderID": this.rowData['orderID'],
        "symbol": this.rowData['symbol'],
        "user": this.UserService.getActiveMPID(),
        "recordType": this.rowData['recordType']
      };
      this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.Comparative_Review_View_Details), data)
        .pipe(map((response: Response) => {
          return response;
        }))
        .subscribe({
          next: (dataset: any) => {
            if(dataset.status === 'true'){
            let data: any = dataset.data;
            this.SelectedRowData=[];
            this.SelectedRowDataLegDetails=[];
            this.SelectedRowData = data;
            this.isLoadingResults = false;
            this.SelectedRowData.forEach((item:any) =>{
              if(item.fieldName=='legDetails'){ 
                 this.catLegDetails = item.catValue!=undefined && item.catValue.trim().length>0  ? JSON.parse(item.catValue): []; 
                 this.clientLegDetails = item.clientValue !=undefined && item.clientValue.trim().length>0? JSON.parse(item.clientValue):[];
                 let isValid = true;
                 this.catLegDetails.forEach((catleg)=>{
                  let item1 = {...item};

                  if(this.clientLegDetails.length>0){
                    this.clientLegDetails.forEach((clientLeg)=>{
                      if(catleg.legRefID == clientLeg.legRefID){
                        item1.valid=true;
                        item1.fieldName="";
                        item1.catValue="Leg Details - "+ catleg.legRefID;
                        item1.clientValue="Leg Details - "+ catleg.legRefID;
                        this.SelectedRowDataLegDetails.push(item1);
                        Object.keys(catleg).forEach((key:any)=>{
                          let item2 = {...item};
                          item2.fieldName=key;
                          item2.catValue=catleg[key]!=undefined ? JSON.stringify(catleg[key]).replaceAll("\"",""):"";
                          item2.clientValue=clientLeg[key]!=undefined ? JSON.stringify(clientLeg[key]).replaceAll("\"",""):"";
                          if(item2.catValue != item2.clientValue){
                            isValid = false;
                          }
                          this.SelectedRowDataLegDetails.push(item2);
                        })
                      }
                    })

                  } 
                  else {
                      item1.valid=true;
                      item1.fieldName="";
                      item1.catValue="Leg Details - "+ catleg.legRefID;
                      item1.clientValue="Leg Details - "+ catleg.legRefID;
                      this.SelectedRowDataLegDetails.push(item1);
                      Object.keys(catleg).forEach((key:any)=>{
                        let item2 = {...item};
                        item2.fieldName=key;
                        item2.catValue=catleg[key]!=undefined ? JSON.stringify(catleg[key]).replaceAll("\"",""):"";
                        item2.clientValue="";
                        if(item2.catValue != item2.clientValue){
                          isValid = false;
                        }
                        this.SelectedRowDataLegDetails.push(item2);
                      });
                  }
                  
                });
                item.valid = isValid;


              }

            });

            this.SelectedRowData =[...this.SelectedRowData, ...this.SelectedRowDataLegDetails];
            if (this.SelectedRowData && this.SelectedRowData.length > 0) {
              this.isSelectedeDetails = true;
            }
          }
          else{
            this.closeDialogBox();
            this.messageService.add({ severity: 'error', summary: 'Error', detail: dataset.msg });
          }
          },
          error: (err: HttpErrorResponse) => {
            this.isLoadingResults = false;
            this.messageService.add({ severity: 'error', summary: 'error', detail: 'Record Not Found' });
          }
        });

    }
  }
  closeDialogBox(){
    this.View=false;
    this.closeDialog.emit(false);
  }
  
}

